<template>
  <el-container style="height: 100vh">
    <el-aside width="200px" style="background-color: #304156">
      <div class="logo">
        <h2 style="color: #fff; text-align: center; padding: 20px 0;">华安云安全小课堂</h2>
      </div>
      <el-menu
        :default-active="activeMenu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
      >
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-data"></i>
          <span slot="title">数据概览</span>
        </el-menu-item>
        
        <!-- 内容管理 -->
        <el-submenu index="content">
          <template slot="title">
            <i class="el-icon-folder"></i>
            <span>内容管理</span>
          </template>
          <el-menu-item index="/videos">
            <i class="el-icon-video-camera"></i>
            <span slot="title">视频管理</span>
          </el-menu-item>
          <el-menu-item index="/questions">
            <i class="el-icon-edit"></i>
            <span slot="title">题库管理</span>
          </el-menu-item>
          <el-menu-item index="/exam-papers">
            <i class="el-icon-document"></i>
            <span slot="title">试卷管理</span>
          </el-menu-item>
          <el-menu-item index="/policy-files">
            <i class="el-icon-document"></i>
            <span slot="title">政策学习</span>
          </el-menu-item>
        </el-submenu>
        
        <!-- 系统模块 -->
        <el-submenu index="user-points">
          <template slot="title">
            <i class="el-icon-user-solid"></i>
            <span>系统模块</span>
          </template>
          <el-menu-item index="/users">
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/user-rank">
            <i class="el-icon-trophy"></i>
            <span slot="title">用户排行榜</span>
          </el-menu-item>
          <el-menu-item index="/points-records">
            <i class="el-icon-coin"></i>
            <span slot="title">积分记录</span>
          </el-menu-item>
        </el-submenu>
        
        <!-- 商城管理 -->
        <el-submenu index="mall">
          <template slot="title">
            <i class="el-icon-shopping-bag-2"></i>
            <span>商城管理</span>
          </template>
          <el-menu-item index="/products">
            <i class="el-icon-goods"></i>
            <span slot="title">商品管理</span>
          </el-menu-item>
          <el-menu-item index="/orders">
            <i class="el-icon-s-order"></i>
            <span slot="title">兑换订单</span>
          </el-menu-item>
        </el-submenu>
        
        <el-menu-item index="/notifications">
          <i class="el-icon-message"></i>
          <span slot="title">消息通知</span>
        </el-menu-item>
        
        <el-menu-item index="/categories">
          <i class="el-icon-menu"></i>
          <span slot="title">分类管理</span>
        </el-menu-item>
        
        <!-- 接口文档 -->
        <el-menu-item @click.native.stop.prevent="openApiDoc">
          <i class="el-icon-document"></i>
          <span slot="title">接口文档</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header style="background-color: #fff; border-bottom: 1px solid #e6e6e6">
        <div style="display: flex; justify-content: flex-end; align-items: center; height: 100%;">
          <span style="margin-right: 20px;">{{ adminInfo.realName || adminInfo.username || '管理员' }}</span>
          <el-button type="danger" size="small" @click="handleLogout">退出</el-button>
        </div>
      </el-header>

      <el-main style="background-color: #f0f2f5">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { API_BASE_URL } from '@/utils/request'

export default {
  name: 'Layout',
  data() {
    return {
      adminInfo: {}
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    }
  },
  mounted() {
    // 获取管理员信息
    const adminInfoStr = localStorage.getItem('adminInfo')
    if (adminInfoStr) {
      try {
        this.adminInfo = JSON.parse(adminInfoStr)
      } catch (e) {
        console.error('解析管理员信息失败:', e)
      }
    }
  },
  methods: {
    handleLogout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('adminInfo')
        this.$message.success('退出成功')
        this.$router.push('/login')
      }).catch(() => {
        // 取消操作
      })
    },
    openApiDoc(event) {
      // 阻止事件冒泡和默认行为
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      // 在新窗口打开接口文档（使用动态API地址）
      window.open(`${API_BASE_URL}/api/doc.html`, '_blank')
      // 返回 false 进一步阻止默认行为
      return false
    }
  }
}
</script>

<style scoped>
.logo {
  border-bottom: 1px solid #1f2d3d;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue